var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFellaApi = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.89 24",
    style: {
      marginBottom: 8
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b7ebe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.36,23.92a6.19,6.19,0,0,1-3-1.18,7.81,7.81,0,0,1-3.18-5c0-.1,0-.2-.07-.31s0-.12,0-.17l0-.09V15.3l.05-.12c.12-.3.23-.61.34-.93a12,12,0,0,1,.94-2.19A7.43,7.43,0,0,1,5.82,9c.31-.09.35-.16.43-.39A10.56,10.56,0,0,1,16.47,1.19a11.69,11.69,0,0,1,1.87.15l.23.06.06,0,.42.12.06.43a1.68,1.68,0,0,1-.61,1.51l-.07.08a3.48,3.48,0,0,1-2.51,1,7.16,7.16,0,0,0-6.77,6.14A1.39,1.39,0,0,1,7.88,12a8.82,8.82,0,0,0-2.15.64,3.7,3.7,0,0,0-2.36,3.7,4.31,4.31,0,0,0,2.52,4.08,3.83,3.83,0,0,0,.49.2l.3.11.42.17V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.68,15.43a20.66,20.66,0,0,1,1.23-3A6.62,6.62,0,0,1,6,9.64a1.1,1.1,0,0,0,.87-.85A10,10,0,0,1,18.23,2l.21.06c.07.47-.19.69-.5,1a2.85,2.85,0,0,1-2.08.79,7.81,7.81,0,0,0-7.38,6.71c-.06.44-.25.61-.72.7A9.62,9.62,0,0,0,5.45,12a4.36,4.36,0,0,0-2.76,4.33A5,5,0,0,0,5.59,21a8.17,8.17,0,0,0,.84.33v1.94a5.62,5.62,0,0,1-2.72-1.06,7,7,0,0,1-2.9-4.62c0-.18-.09-.35-.13-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.46,23.68H28.2l-.63-.05V22.53c0-.42,0-.85,0-1.28a1.34,1.34,0,0,1,.76-1,5.55,5.55,0,0,0,1.87-8.74,1.48,1.48,0,0,1-.45-1.23,1.41,1.41,0,0,1,.81-.94A1.87,1.87,0,0,0,30.94,9l.3-.31.44-.4.46.38A7.18,7.18,0,0,1,34.3,12a16.45,16.45,0,0,1,.42,1.64l.15.69,0,.08v2c0,.14-.06.28-.08.41-.06.3-.12.61-.19.92-.69,2.92-2.62,4.86-5.89,5.94A.78.78,0,0,1,28.46,23.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.22,16.24c-.09.44-.17.88-.27,1.31-.69,2.94-2.71,4.55-5.44,5.45a.87.87,0,0,1-.26,0c0-.56,0-1.12,0-1.68a.68.68,0,0,1,.37-.45,6.23,6.23,0,0,0,2.09-9.79c-.43-.51-.43-.81.17-1.13a4.77,4.77,0,0,0,.8-.73,6.56,6.56,0,0,1,2,3c.25.74.38,1.52.56,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.43,23.58c-.76,0-1.42,0-2.06,0-.17,0-.41-.31-.46-.52a.72.72,0,0,0-.94-.66,3.14,3.14,0,0,1-.81,0c-.71-.08-1.29,0-1.37.9,0,.11-.24.28-.37.29-.64,0-1.29,0-2,0L10,19.22,11,16.76c0-.1.07-.29.12-.3.71-.09,1.41-.19,2.12-.22a.69.69,0,0,1,.57.3C14.66,18.83,15.51,21.14,16.43,23.58Zm-3.23-2.8-.76-2.47-.13,0-.74,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.28,23.55H17.07V16.27c1.49,0,3-.1,4.43,0,1.28.11,1.87,1.07,1.77,2.49a2.16,2.16,0,0,1-2.19,2.05c-.55,0-1.11,0-1.8,0v2.71Zm0-4.18c.6-.06,1.25.2,1.62-.43a.93.93,0,0,0,0-.8c-.39-.62-1-.39-1.62-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.27,16.24h2.19v7.3H24.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.08,6.27H20.64V3.61h3.44V0h2.73V3.61h3.45V6.27H26.81v3.6H24.08Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFellaApi, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FellaApi.5d3ef777.svg";
export { ForwardRef as ReactComponent };